import { FC } from "react";
import { Typography, Descriptions, Space, Alert } from "antd";
import { PublicPageLayout } from "../../components/public/PublicPageLayout";
import { SEOHead } from "../../components/SEOHead";
import {
  PUBLIC_PLAN_ORDER,
  formatPlanMonthlyPriceWithTax,
  getSubscriptionPlanConfig,
} from "@shared/config/subscription-plans";

const { Text } = Typography;

const planPricingPhrase = PUBLIC_PLAN_ORDER
  .map((code) => {
    const plan = getSubscriptionPlanConfig(code);
    return `${plan.label} ${formatPlanMonthlyPriceWithTax(plan, { withSuffix: true })}`;
  })
  .join("、");

export const SpecifiedCommercialTransactionsPage: FC = () => {
  return (
    <>
      <SEOHead
        title="特定商取引法に基づく表記｜一元帳"
        description="一元帳の特定商取引法に基づく表記です。"
      />
      <PublicPageLayout
        title="特定商取引法に基づく表示"
        subtitle="契約プラン型B2Bサービスとして必要な法定表記を掲載しています。"
      >
      <Space direction="vertical" size={32} style={{ width: "100%" }}>
        <Alert type="info" showIcon message="本サービスは法人向けのB2B契約プランです。お問い合わせはフォームより承ります。" />

        <Alert
          type="warning"
          showIcon
          message="解約・自動更新について（重要）"
          description="月額契約は自動継続となり、解約希望の場合は所定フォームから解約申請が必要です。月額契約の途中解約による日割り返金はありません。"
          style={{ borderColor: '#faad14' }}
        />

        <Descriptions bordered column={1} size="middle" colon={false}>
          <Descriptions.Item label="販売事業者">株式会社DiO（DiO Inc.）</Descriptions.Item>
          <Descriptions.Item label="運営責任者">代表取締役 一筆 芳巳</Descriptions.Item>
          <Descriptions.Item label="所在地">〒602-8061 京都府京都市上京区甲斐守町97番地 西陣産業創造會舘</Descriptions.Item>
          <Descriptions.Item label="連絡先">
            電話番号: 非公開（お電話でのサポートは行っておりません）<br />
            お問い合わせフォーム: <a href="/contact">/contact</a><br />
            サポートメール: support@dio-meta.com（営業日 9:00〜17:00）
          </Descriptions.Item>
          <Descriptions.Item label="販売価格">
            サービス内容・料金プランページに記載の月額利用料（無料登録0円、{planPricingPhrase}）。価格改定時は本ページおよびサービスページで告知します。
          </Descriptions.Item>
          <Descriptions.Item label="商品代金以外の必要料金">
            消費税／設備数追加（50台ごとに月額+22,000円）／ストレージ容量追加（50GBごとに月額+5,500円）。通信費に関わる費用はお客様負担です。
          </Descriptions.Item>
          <Descriptions.Item label="支払方法">
            クレジットカード決済。
          </Descriptions.Item>
          <Descriptions.Item label="支払時期">
            初回利用月：利用開始日から当月末日までの日割り計算による料金を請求。２ヶ月目以降：毎月末日を請求基準日とし、翌月分の月額料金全額を請求。クレジットカードは即時決済。
          </Descriptions.Item>
          <Descriptions.Item label="サービス提供時期">
            契約手続き完了後、発行日から利用可能。無料登録は申込当日発行されます。
          </Descriptions.Item>
          <Descriptions.Item label="返品・キャンセル">
            デジタルサービスの性質上、契約成立後の返品・返金はお受けできません。サービス提供が困難な障害が発生した場合は利用料金の返金等で対応します。
          </Descriptions.Item>
          <Descriptions.Item label="解約・自動更新">
            月額契約は自動継続となり、解約希望の場合は所定フォームから解約申請が必要です。
          </Descriptions.Item>
          <Descriptions.Item label="中途解約">
            月額契約の途中解約による日割り返金はありません。解約は次回請求日の前日までに申請することで、次回以降の課金を停止できます。
          </Descriptions.Item>
          <Descriptions.Item label="動作環境">
            推奨ブラウザ：最新のGoogle Chrome / Microsoft Edge / Safari。通信環境：下り10Mbps以上を推奨。
          </Descriptions.Item>
          <Descriptions.Item label="特別条件">
            反社会的勢力排除条項および輸出管理規制へ準拠しています。大規模障害時は代替手段としてCSVレポート提供等を行います。
          </Descriptions.Item>
        </Descriptions>

        <Space direction="vertical" size="small">
          <Text type="secondary">役務提供地域：日本国内（海外利用は個別相談）</Text>
          <Text type="secondary">最終更新日：2025年11月10日</Text>
        </Space>
      </Space>
    </PublicPageLayout>
    </>
  );
};

export default SpecifiedCommercialTransactionsPage;
